import './home.view.scss';

import { A } from '@solidjs/router';

export function HomeView() {
	return (
		<div class="ta-center home narrow">
			<div class="teaser glass">
				<img src="/assets/images/newlyweds.jpeg" />
			</div>

			<div class="content ">
				<p class="headline p-24">
					Hochzeit von <br />
					Lea & Etienne
				</p>

				<div>
					<p>Schön, dass du da bist!</p>
					<p>
						Hier kannst du uns deine Videos & Bilder von unserer Hochzeit
						hochladen.
						<br />
					</p>
					<p>Wir freuen uns über jede Erinnerung!</p>
					<div class="mb-24">
						<A href="/upload">
							<button>Jetzt hochladen!</button>
						</A>
					</div>
				</div>
			</div>

			<div class="copyright">
				<span>Erstellt von Marco Klein&nbsp;-&nbsp;</span>
				<a href="https://marcoklein.engineer/" target="_blank" rel="noopener noreferrer">
					marcoklein.engineer
				</a>
			</div>
		</div>
	);
}
